var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.143,
    height: 20,
    viewBox: "0 0 17.143 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M18.786,10.821a2.857,2.857,0,0,1,2.857,2.857v5.714a2.857,2.857,0,0,1-2.857,2.857H7.357A2.857,2.857,0,0,1,4.5,19.393V13.679a2.857,2.857,0,0,1,2.857-2.857V7.964a5.714,5.714,0,1,1,11.429,0ZM13.071,4.155a3.81,3.81,0,0,1,3.81,3.81v2.857H9.262V7.964a3.81,3.81,0,0,1,3.81-3.81Zm5.714,8.571H7.357a.952.952,0,0,0-.952.952v5.714a.952.952,0,0,0,.952.952H18.786a.952.952,0,0,0,.952-.952V13.679A.952.952,0,0,0,18.786,12.726Z",
    transform: "translate(-4.5 -2.25)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f3b19dde642277ac313bedc3aad86bc6.svg";
export { ForwardRef as ReactComponent };